let GetpolisConstants = {
    install(Vue, options) {
        Vue.GetpolisConstants = {
            // Цели спользования
            USE_TYPES: {
                // Личная
                PERSONAL: 1,
                // Такси
                TAXI: 2,
                // Регулярные пассажирские перевозки
                REGULAR_TRANSPORTATION: 6
            },
            RECAPTCHA_SITEKEY: '6LetiSQbAAAAAHUXbm8X3V8W560pBAgimIQBHlfY',
            RECAPTCHA_ACTIONS: {
                NUMBER: 'number',
                POLICY: 'policy',
                DCARD: 'dcard',
                GIBDD: 'gibdd',
                TRANSPORT: 'transport',
                KBM: 'kbm'
            },
            // Типы контрагентов
            USER_TYPES: {
                // ЮЛ
                JURIDICAL: 'juridical',
                // ФЛ
                PHYSICAL: 'physical',
                // Самозанятый
                SELF_EMPLOYED: 'self-employed',
                // ИП
                SOLE_PROPRIETOR: 'sole-proprietor'
            },
            // Типы агентов
            AGENT_TYPES: {
                ADMIN: 'admin',
                CURATOR: 'curator',
                AGENT: 'agent',
                OPERATOR: 'operator'
            }
        };
    }
};

export default GetpolisConstants;



// WEBPACK FOOTER //
// ./resources/js/plugins/GetpolisConstants.js